export default "__VITE_ASSET__3843903c__"